module.exports = __webpack_public_path__ + "static/media/app-bar-account.2d0e0b01.svg";